import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const CambodiaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15310'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15310)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 3.73333H20V0H0V3.73333Z'
					fill='#0F3EB6'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14.0001H20V10.2667H0V14.0001Z'
					fill='#0F3EB6'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 10.2666H20V3.73328H0V10.2666Z'
					fill='#ED1A3C'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.57236 6.10902H9.52474V5.60949C9.52474 5.3465 9.73794 5.1333 10.0009 5.1333C10.2639 5.1333 10.4771 5.3465 10.4771 5.60949V6.10902H11.4295V6.99997H8.57236V6.10902ZM12.3819 5.59997C12.1189 5.59997 11.9057 5.81317 11.9057 6.07616V6.99997H12.8581V6.07616C12.8581 5.81317 12.6449 5.59997 12.3819 5.59997ZM8.09617 9.3333V7.46663H7.14379L6.19141 9.3333H8.09617ZM8.57236 7.46663V9.3333H11.4295V7.46663H8.57236ZM11.9057 9.3333V7.46663H12.8581L13.8105 9.3333H11.9057ZM7.61998 5.59997C7.35698 5.59997 7.14379 5.81317 7.14379 6.07616V6.99997H8.09617V6.07616C8.09617 5.81317 7.88297 5.59997 7.61998 5.59997Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default CambodiaFlagIcon;
